export const isLeap = year => new Date(year, 1, 29).getDate() === 29;

export const getBlobType = format => {
  switch (format) {
    case 'png':
      return 'image/png';
    case 'jpg':
      return 'image/jpg';
    case 'jpeg':
      return 'image/jpeg';
    case 'pdf':
      return 'application/pdf';
    default:
      break;
  }
  return '';
};

function p8(s) {
  const p = Math.random()
    .toString(16)
    .concat('000000000')
    .substr(2, 8);
  return s ? `${p.substr(0, 4)}-${p.substr(4, 4)}` : p;
}

export const createGuid = () => p8() + p8(true) + p8(true) + p8();
export const getFileExtension = fileUrl => {
  if (fileUrl) {
    const re = /(?:\.([^.]+))?$/;
    return re.exec(fileUrl)[1];
  }
  return '';
};
export function getFileName(url) {
  if (url.length === 1) {
    const realUrl = url[0];
    return realUrl.split('?')[0].match(/([^/]+)(?=\.\w+$)/)[0];
  }
  return url ? url.split('?')[0].match(/([^/]+)(?=\.\w+$)/)[0] : '';
}
export const createUrlForSrc = (imgSrc, format /* size */) => {
  const blob = new Blob([imgSrc], { type: getBlobType(format) });
  const urlCreator = window.URL || window.webkitURL;
  let snackbar = {
    open: false,
    text: '',
  };
  if (
    format !== 'pdf' &&
    format !== 'png' &&
    format !== 'jpeg' &&
    format !== 'jpg'
  ) {
    snackbar = {
      open: true,
      text: 'El formato del archivo no es válido',
    };
  }
  // if (size > 5000000) {
  //   snackbar = {
  //     open: true,
  //     text: "El tamaño del archivo debe ser menor a 5MB",
  //   };
  // }
  const node = {
    imageUrl: snackbar.open ? '' : urlCreator.createObjectURL(blob),
    snackbar,
  };
  return node;
};

export const getCelphone = value => {
  const inputOriginal = value.toString();
  let input;
  input = inputOriginal.replace(/\D/g, '');
  input = input.substring(0, 10);
  const sizePhone = input.length;
  if (sizePhone === 0) {
    input = '';
  } else if (sizePhone < 4) {
    input = `(${input}`;
  } else if (sizePhone < 7) {
    input = `(${input.substring(0, 3)}) ${input.substring(3, 6)}`;
  } else {
    input = `(${input.substring(0, 3)}) ${input.substring(
      3,
      6,
    )} - ${input.substring(6, 10)}`;
  }
  return input;
};

export const getCardType = number => {
  let re = new RegExp('^4');
  if (number.match(re) != null) return 'Visa';
  if (
    /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(
      number,
    )
  ) {
    return 'Mastercard';
  }
  re = new RegExp('^3[47]');
  if (number.match(re) != null) return 'AMEX';
  re = new RegExp(
    '^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)',
  );
  if (number.match(re) != null) return 'Discover';
  re = new RegExp('^36');
  if (number.match(re) != null) return 'Diners';
  re = new RegExp('^30[0-5]');
  if (number.match(re) != null) return 'Diners - Carte Blanche';
  re = new RegExp('^35(2[89]|[3-8][0-9])');
  if (number.match(re) != null) return 'JCB';
  re = new RegExp('^(4026|417500|4508|4844|491(3|7))');
  if (number.match(re) != null) return 'Visa Electron';
  return '';
};

export const alphanumericExpression = /[^\wÀÁÂÃÄÅàáâãäåÒÓÔÕÖØòóôõöøÈÉÊËèéêëÇçÌÍÎÏìíîïÙÚÛÜùúûüÿÑñ´ ]/g;

export const createUrlPdfFromArraybuffer = buffer => {
  const arrayBuffer = new Uint8Array(buffer).buffer;
  const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
  const urlCreator = window.URL || window.webkitURL;
  return urlCreator.createObjectURL(blob);
};

export const mediaQueryXSmall = '@media (max-width: 576px)';
export const mediaQuerySmall = '@media (max-width: 768px)';
export const mediaQueryMedium = '@media (max-width: 992px)';
export const mediaQueryLarge = '@media (max-width: 1200px)';

export const media = {
  xSmall: mediaQueryXSmall,
  small: mediaQuerySmall,
  medium: mediaQueryMedium,
  large: mediaQueryLarge,
};

export default {
  isLeap,
  getBlobType,
  createUrlForSrc,
  getCardType,
  alphanumericExpression,
  createUrlPdfFromArraybuffer,
  media,
};
